import { connect } from "react-redux";
import { merklistenProductResponseSelector, merklistenSelector } from "../../../modules/selectors/merkliste";
import { useCallback, useEffect } from "react";
import { markenStandortSelector } from "../../../modules/selectors/standort/markenStandort";
import MerklistenProductDetail from "./MerklistenProductDetail";
import MerklistenTireDetail from "./MerklistenTireDetail";
import BreadCrumbSelector from "../../components/BreadCrumb/BreadCrumbSelector";
import ReduxSuspense from "../../components/ReduxSuspense/ReduxSuspense";
import InlineSpinner from "../../components/Spinner/InlineSpinner";
import { fetchMerklistenProductsIfNeeded } from '../../../modules/actions/merkliste';
import { useDispatch } from 'react-redux';

const Merkliste = ({ merklistenProductsResponse, merkliste, markenStandort }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const storedMerkliste = localStorage.getItem('merkliste');
        if (storedMerkliste && storedMerkliste.length > 0) {
            dispatch(fetchMerklistenProductsIfNeeded())
        }
    }, [dispatch])

    const checkMerklistenLength = useCallback(() => {
        return merkliste.filter(entry => entry.standort === markenStandort._id).length
    }, [merkliste, markenStandort])

    let additionalCrumbs = [
        {
            label: "Merkliste",
            key: "merkliste"
        },
    ];

    return (
        <>
            <BreadCrumbSelector additionalCrumbs={additionalCrumbs} />

            <section className="uk-section uk-section-default uk-section-small">
                <div className="uk-container uk-margin-medium-top uk-text-center" data-uk-margin="">
                    <h1>Mein Merkzettel ({checkMerklistenLength()})</h1>

                    <hr className="uk-margin-large" style={{ border: "2px solid black" }} />
                    <div className="uk-grid uk-child-width-1-1 uk-first-column" data-uk-grid="">
                        {
                            merkliste?.length > 0 &&
                            <ReduxSuspense response={merklistenProductsResponse} fallback={<InlineSpinner />}>
                                {products => {
                                    return [...products].reverse().map((product, index) => {
                                        return (
                                            <div key={`merklisten_key_${index}`}>
                                                {product?.categories && product.categories[0] === 'reifen'
                                                    ? <MerklistenTireDetail tireDetail={product} />
                                                    : <MerklistenProductDetail product={product} productUrl={product._id} categoryUrl={product.varianten[0]?.category ? product.varianten[0]?.category[0] : product.varianten[0]?.categories[0]} />
                                                }
                                                {index + 1 !== products.length && <hr className="uk-margin-large-top uk-margin-large-bottom" />}
                                            </div>
                                        )
                                    })

                                }}
                            </ReduxSuspense>
                        }
                    </div>
                </div>
            </section>


        </>
    )
}



const mapStateToProps = state => {
    return {
        merkliste: merklistenSelector(state),
        markenStandort: markenStandortSelector(state),
        merklistenProductsResponse: merklistenProductResponseSelector(state),
    }
};

const mapDispatchToProps = { };

export default connect(mapStateToProps, mapDispatchToProps)(Merkliste);

